(function () {
  'use strict';

  var activePanel = null;

  function initHeader() {
    var hdr = document.querySelector('.hdr');
    if (!hdr) return;
    var last = 0;
    var isMobile = function () { return window.innerWidth <= 860; };

    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      if (y > 80 && y > last) {
        hdr.classList.add('is-hidden');
        hdr.classList.remove('is-scrolled');
      } else if (y < last) {
        hdr.classList.remove('is-hidden');
        if (isMobile() && y > 10) hdr.classList.add('is-scrolled');
      }
      if (y <= 10) {
        hdr.classList.remove('is-hidden');
        hdr.classList.remove('is-scrolled');
      }
      last = y;
    }, { passive: true });
  }

  function closeAllPanels() {
    document.querySelectorAll('.mob-panel').forEach(function (p) { p.classList.remove('is-open'); });
    var hdr = document.querySelector('.hdr');
    if (hdr) hdr.classList.remove('is-panel-open');
    document.body.classList.remove('no-scroll');
    document.documentElement.classList.remove('no-scroll');
    var ov = document.querySelector('.cart-panel-ov');
    if (ov) ov.classList.remove('is-open');
    activePanel = null;
  }

  function openPanel(name) {
    var hdr = document.querySelector('.hdr');
    if (activePanel === name) { closeAllPanels(); return; }
    closeAllPanels();
    var panel = document.querySelector('[data-mob-panel="' + name + '"]');
    if (!panel) return;
    panel.classList.add('is-open');
    if (hdr) { hdr.classList.add('is-panel-open'); hdr.classList.remove('is-hidden'); }
    document.body.classList.add('no-scroll');
    document.documentElement.classList.add('no-scroll');
    activePanel = name;

    if (name === 'search') {
      var input = panel.querySelector('[data-mob-search-input]');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }

    if (name === 'cart' && window.innerWidth > 860) {
      var ov = document.querySelector('.cart-panel-ov');
      if (ov) ov.classList.add('is-open');
    }
  }

  function initPanels() {
    document.querySelectorAll('[data-panel-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var name = btn.getAttribute('data-panel-toggle');
        if (name === 'cart') {
          openPanel(name);
        } else if (window.innerWidth <= 860) {
          openPanel(name);
        }
      });
    });

    document.querySelectorAll('[data-panel-close]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closeAllPanels();
      });
    });
  }

  function initMobileTabs() {
    document.querySelectorAll('.mob-panel__tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var panel = tab.closest('.mob-panel');
        if (!panel) return;
        panel.querySelectorAll('.mob-panel__tab').forEach(function (t) { t.classList.remove('is-active'); });
        panel.querySelectorAll('.mob-panel__cat-group').forEach(function (g) { g.classList.remove('is-active'); });
        tab.classList.add('is-active');
        var key = tab.getAttribute('data-mob-tab');
        var group = panel.querySelector('[data-mob-cat="' + key + '"]');
        if (group) group.classList.add('is-active');
      });
    });
  }

  function initMobileSearchPanel() {
    var panel = document.querySelector('[data-mob-panel="search"]');
    if (!panel) return;
    var clearBtn = panel.querySelector('[data-mob-search-clear]');
    var input = panel.querySelector('[data-mob-search-input]');
    if (clearBtn && input) {
      clearBtn.addEventListener('click', function () { input.value = ''; input.focus(); });
    }
    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && input.value.trim()) {
          window.location.href = window.__rootUrl + 'search?q=' + encodeURIComponent(input.value.trim());
        }
      });
    }
  }

  function initDesktopSearch() {
    var overlay = document.querySelector('[data-search-overlay]');
    var backdrop = document.querySelector('[data-search-backdrop]');
    var input = overlay ? overlay.querySelector('[data-search-input]') : null;
    if (!overlay) return;

    function openSearch() {
      if (window.innerWidth <= 860) return;
      overlay.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.classList.add('no-scroll');
      if (input) setTimeout(function () { input.focus(); }, 50);
    }
    function closeSearch() {
      overlay.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }

    document.querySelectorAll('[data-search-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        if (window.innerWidth > 860) openSearch();
      });
    });
    overlay.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });
    if (backdrop) backdrop.addEventListener('click', closeSearch);

    if (input) {
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' && input.value.trim()) {
          window.location.href = window.__rootUrl + 'search?q=' + encodeURIComponent(input.value.trim());
        }
      });
    }
  }

  function handleize(str) {
    return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function initMegaMenu() {
    var triggers = document.querySelectorAll('[data-nav-trigger]');
    var megas = document.querySelectorAll('[data-mega]');
    var overlay = document.querySelector('[data-mega-overlay]');
    var closeTimer;

    function closeAll() {
      megas.forEach(function (m) { m.classList.remove('is-open'); });
      if (overlay) overlay.classList.remove('is-open');
    }

    triggers.forEach(function (t) {
      var parent = t.closest('[data-nav-drop]');
      var key = t.getAttribute('data-mega-key') || handleize(t.textContent.trim());
      var mega = document.querySelector('[data-mega="' + key + '"]');

      t.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        closeAll();
        if (mega) { mega.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); }
      });

      if (parent) {
        parent.addEventListener('mouseleave', function () {
          closeTimer = setTimeout(closeAll, 150);
        });
      }

      if (mega) {
        mega.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
        mega.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 150); });
      }
    });
  }

  function initCart() {
    var ov = document.querySelector('.cart-panel-ov');
    if (ov) ov.addEventListener('click', closeAllPanels);

    var closeBtn = document.querySelector('[data-cart-panel-close]');
    if (closeBtn) closeBtn.addEventListener('click', function (e) { e.preventDefault(); closeAllPanels(); });

    window.__cart = { open: function () { openPanel('cart'); }, close: closeAllPanels, refresh: refreshCart };
  }

  function refreshCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? '' : 'none';
      });

      var items = document.querySelector('.cart-p__items');
      var empty = document.querySelector('[data-cart-empty]');
      var sub = document.querySelector('[data-cart-subtotal]');

      if (!items) return;

      if (cart.item_count === 0) {
        items.innerHTML = '';
        if (empty) empty.style.display = '';
      } else {
        if (empty) empty.style.display = 'none';
        items.innerHTML = cart.items.map(function (item) {
          var sizeHtml = item.variant_title && item.variant_title !== 'Default Title'
            ? '<span class="cart-p__item-size">' + item.variant_title + '</span>' : '';
          return '<div class="cart-p__item" data-item-key="' + item.key + '">'
            + '<a href="' + item.url + '" class="cart-p__item-img"><img src="' + item.image + '" alt="" loading="lazy"></a>'
            + '<div class="cart-p__item-info">'
            + '<div class="cart-p__item-name">' + item.product_title + '</div>'
            + '<div class="cart-p__item-price">' + fmt(item.final_line_price) + '</div>'
            + '<div class="cart-p__item-qty">'
            + '<button class="cart-p__item-qty-btn" data-qty-minus="' + item.key + '">\u2212</button>'
            + '<span class="cart-p__item-qty-val">' + item.quantity + '</span>'
            + '<button class="cart-p__item-qty-btn" data-qty-plus="' + item.key + '">+</button>'
            + sizeHtml
            + '</div></div></div>';
        }).join('');
        bindCartQty();
      }
      if (sub) sub.textContent = fmt(cart.total_price);
    });
  }

  function changeQty(key, delta) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var item = cart.items.find(function (i) { return i.key === key; });
      var newQty = item ? item.quantity + delta : 0;
      if (newQty < 1) newQty = 0;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      }).then(function () { refreshCart(); });
    });
  }

  function bindCartQty() {
    document.querySelectorAll('[data-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(btn.getAttribute('data-qty-minus'), -1); });
    });
    document.querySelectorAll('[data-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () { changeQty(btn.getAttribute('data-qty-plus'), 1); });
    });
  }

  function fmt(c) {
    var tpl = window.__moneyFormat || '{{amount}} \u20AC';
    var val = (c / 100).toFixed(2);
    var parts = val.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    var decimal = parts[1];
    var noTrail = (decimal === '00');
    var result = tpl
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, noTrail ? whole.replace(/ /g, '.') : whole.replace(/ /g, '.') + ',' + decimal)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, whole.replace(/ /g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, whole)
      .replace(/\{\{\s*amount\s*\}\}/g, noTrail ? whole : whole + '.' + decimal);
    return result;
  }

  function initAddToCart() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]'); var txt = btn.textContent;
        btn.disabled = true; btn.textContent = '...';
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(form.querySelector('[name="id"]').value), quantity: 1 }] }) })
        .then(function () { btn.textContent = txt; btn.disabled = false; refreshCart(); openPanel('cart'); })
        .catch(function () { btn.textContent = txt; btn.disabled = false; });
      });
    });
  }

  function initFilters() {
    /* handled by inline JS in collection.liquid */
  }

  function initAccordions() {
    document.querySelectorAll('.pdp__accordion-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var body = btn.nextElementSibling;
        var open = btn.classList.toggle('is-open');
        body.style.maxHeight = open ? body.scrollHeight + 'px' : '0';
      });
    });
  }

  function initSizes() {
    var c = document.querySelector('.pdp__sizes'); if (!c) return;
    c.querySelectorAll('.pdp__size:not(.is-disabled)').forEach(function (btn) {
      btn.addEventListener('click', function () {
        c.querySelectorAll('.pdp__size').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var input = document.querySelector('input[name="id"]');
        if (input && btn.dataset.variant) input.value = btn.dataset.variant;
      });
    });
  }

  function initProductShowcase() {
    document.querySelectorAll('[data-psc]').forEach(function (psc) {
      var track = psc.querySelector('[data-psc-track]');
      var prev = psc.querySelector('[data-psc-prev]');
      var next = psc.querySelector('[data-psc-next]');
      var dotsWrap = psc.querySelector('[data-psc-dots]');
      if (!track) return;

      var idx = 0;
      var startX = 0, startY = 0, dx = 0, dy = 0, dragging = false, locked = false;

      function vis() { return window.innerWidth <= 860 ? 1 : 4; }
      function allSlides() { return track.querySelectorAll('.psc__slide'); }
      function total() { return allSlides().length; }
      function maxIdx() { return Math.max(0, total() - vis()); }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        var n = total();
        for (var i = 0; i < n; i++) {
          var dot = document.createElement('button');
          dot.className = 'psc__dot' + (i === idx ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.setAttribute('data-psc-dot', i);
          dotsWrap.appendChild(dot);
        }
      }

      function updateDots() {
        if (!dotsWrap) return;
        dotsWrap.querySelectorAll('.psc__dot').forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }

      function update() {
        var s = allSlides(); if (!s.length) return;
        var w = s[0].offsetWidth;
        var gap = window.innerWidth <= 860 ? 0 : 24;
        track.style.transform = 'translateX(' + (-(w + gap) * idx) + 'px)';
        updateDots();
      }

      if (prev) prev.addEventListener('click', function () {
        idx = idx <= 0 ? maxIdx() : idx - 1;
        update();
      });
      if (next) next.addEventListener('click', function () {
        idx = idx >= maxIdx() ? 0 : idx + 1;
        update();
      });

      if (dotsWrap) dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-psc-dot]');
        if (dot) { idx = parseInt(dot.getAttribute('data-psc-dot'), 10); update(); }
      });

      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dragging = true; locked = false; dx = 0; dy = 0;
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        dx = e.touches[0].clientX - startX;
        dy = e.touches[0].clientY - startY;
        if (!locked) {
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
            locked = true;
          } else if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) {
            dragging = false;
            return;
          }
        }
        if (locked) e.preventDefault();
      }, { passive: false });

      track.addEventListener('touchend', function () {
        if (!dragging) return; dragging = false;
        if (locked) {
          if (dx < -30) idx = Math.min(maxIdx(), idx + 1);
          else if (dx > 30) idx = Math.max(0, idx - 1);
          update();
        }
        locked = false;
      });

      buildDots();
      update();
      window.addEventListener('resize', function () { idx = Math.min(idx, maxIdx()); buildDots(); update(); });
    });
  }

  function initCarousel() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var bar = carousel.querySelector('[data-carousel-bar]');
      if (!track) return;

      var index = 0;
      function getVisible() { return window.innerWidth <= 860 ? 2 : 4; }
      function getSlides() { return track.querySelectorAll('.img-carousel__slide'); }
      function getMax() { return Math.max(0, getSlides().length - getVisible()); }

      function update() {
        var slides = getSlides();
        if (slides.length === 0) return;
        var slideW = slides[0].offsetWidth;
        var gap = window.innerWidth <= 860 ? 12 : 20;
        track.style.transform = 'translateX(' + (-(slideW + gap) * index) + 'px)';
        if (bar) {
          var total = slides.length;
          var vis = getVisible();
          var pct = total <= vis ? 100 : ((index + vis) / total) * 100;
          bar.style.width = Math.min(pct, 100) + '%';
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { index = Math.max(0, index - 1); update(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { index = Math.min(getMax(), index + 1); update(); });
      update();
      window.addEventListener('resize', function () { index = Math.min(index, getMax()); update(); });
    });
  }

  var i18n = {
    fr: {
      detected: function (name, cur) { return 'Vous êtes sur le site ' + name + ', vos achats sont en ' + cur + '. Veuillez confirmer ou modifier vos préférences ci-dessous.'; },
      confirm: 'CONFIRMER & FERMER'
    },
    en: {
      detected: function (name, cur) { return 'You are on the ' + name + ' site, shopping in ' + cur + '. Please confirm or change your preferences below.'; },
      confirm: 'CONFIRM & CLOSE'
    }
  };

  function localeForCountry(code) {
    return code === 'FR' ? 'fr' : 'en';
  }

  var countryEN = {DE:'Germany',AT:'Austria',BE:'Belgium',BG:'Bulgaria',CA:'Canada',HR:'Croatia',DK:'Denmark',ES:'Spain',EE:'Estonia',US:'United States',FI:'Finland',FR:'France',GR:'Greece',HU:'Hungary',IE:'Ireland',IT:'Italy',LV:'Latvia',LT:'Lithuania',LU:'Luxembourg',MT:'Malta',NL:'Netherlands',PL:'Poland',PT:'Portugal',CZ:'Czech Republic',RO:'Romania',GB:'United Kingdom',SK:'Slovakia',SI:'Slovenia',SE:'Sweden',CH:'Switzerland',NO:'Norway',CY:'Cyprus'};

  function initCountryPopup() {
    var popup = document.querySelector('[data-country-popup]');
    if (!popup) return;
    var select = popup.querySelector('[data-country-select]');
    var detected = popup.querySelector('[data-country-detected]');
    var btn = popup.querySelector('[data-country-confirm]');
    var localeInput = popup.querySelector('[data-popup-locale]');
    var form = popup.querySelector('#country-popup-form');

    if (select) {
      for (var i = 0; i < select.options.length; i++) {
        var o = select.options[i];
        var en = countryEN[o.value];
        if (en) {
          var cur = o.getAttribute('data-currency') || 'EUR';
          o.text = en + ' (' + cur + ')';
        }
      }
    }

    function updatePopupUI(opt) {
      if (!opt) return;
      var locale = localeForCountry(opt.value);
      var currency = opt.getAttribute('data-currency') || 'EUR';
      var name = opt.text.replace(/\s*\(.*\)/, '');
      var t = i18n.en;
      if (detected) detected.textContent = t.detected(name, currency);
      if (btn) btn.textContent = t.confirm;
      if (localeInput) localeInput.value = locale;
    }

    var saved = localStorage.getItem('lunara_country');
    if (!saved) {
      setTimeout(function () { popup.classList.add('is-open'); }, 600);
    }

    if (select) {
      updatePopupUI(select.options[select.selectedIndex]);
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        if (opt) updatePopupUI(opt);
      });
    }

    if (select && !saved) {
      fetch('https://get.geojs.io/v1/ip/country.json')
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var code = d && d.country ? d.country.toUpperCase() : '';
          if (!code) return;
          for (var i = 0; i < select.options.length; i++) {
            if (select.options[i].value === code) {
              select.selectedIndex = i;
              updatePopupUI(select.options[i]);
              break;
            }
          }
        })
        .catch(function () {});
    }

    if (btn && form) {
      btn.addEventListener('click', function () {
        if (!select) return;
        if (localeInput) localeInput.value = localeForCountry(select.value);
        localStorage.setItem('lunara_country', select.value);
        form.submit();
      });
    }
  }

  function initTestimonials() {
    document.querySelectorAll('[data-tt]').forEach(function (tt) {
      var track = tt.querySelector('[data-tt-track]');
      var dotsWrap = tt.querySelector('[data-tt-dots]');
      if (!track) return;

      var idx = 0;
      var startX = 0, startY = 0, dx = 0, dy = 0, dragging = false, locked = false;

      function vis() { return window.innerWidth <= 860 ? 1 : 3; }
      function allSlides() { return track.querySelectorAll('.tt__slide'); }
      function total() { return allSlides().length; }
      function maxIdx() { return Math.max(0, total() - vis()); }

      function buildDots() {
        if (!dotsWrap) return;
        dotsWrap.innerHTML = '';
        var n = total();
        for (var i = 0; i < n; i++) {
          var dot = document.createElement('button');
          dot.className = 'tt__dot' + (i === idx ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Slide ' + (i + 1));
          dot.setAttribute('data-tt-dot', i);
          dotsWrap.appendChild(dot);
        }
      }

      function updateDots() {
        if (!dotsWrap) return;
        dotsWrap.querySelectorAll('.tt__dot').forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
      }

      function update() {
        var s = allSlides(); if (!s.length) return;
        var w = s[0].offsetWidth;
        var gap = window.innerWidth <= 860 ? 0 : 80;
        track.style.transform = 'translateX(' + (-(w + gap) * idx) + 'px)';
        updateDots();
      }

      if (dotsWrap) dotsWrap.addEventListener('click', function (e) {
        var dot = e.target.closest('[data-tt-dot]');
        if (dot) { idx = parseInt(dot.getAttribute('data-tt-dot'), 10); update(); }
      });

      track.addEventListener('touchstart', function (e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        dragging = true; locked = false; dx = 0; dy = 0;
      }, { passive: true });

      track.addEventListener('touchmove', function (e) {
        if (!dragging) return;
        dx = e.touches[0].clientX - startX;
        dy = e.touches[0].clientY - startY;
        if (!locked) {
          if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
            locked = true;
          } else if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) {
            dragging = false;
            return;
          }
        }
        if (locked) e.preventDefault();
      }, { passive: false });

      track.addEventListener('touchend', function () {
        if (!dragging) return; dragging = false;
        if (locked) {
          if (dx < -30) idx = Math.min(maxIdx(), idx + 1);
          else if (dx > 30) idx = Math.max(0, idx - 1);
          update();
        }
        locked = false;
      });

      buildDots();
      update();
      window.addEventListener('resize', function () { idx = Math.min(idx, maxIdx()); buildDots(); update(); });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initPanels();
    initMobileTabs();
    initMobileSearchPanel();
    initDesktopSearch();
    initMegaMenu();
    initProductShowcase();
    initTestimonials();
    initCarousel();
    initCart();
    initAddToCart();
    initFilters();
    initAccordions();
    initSizes();
    refreshCart();
    bindCartQty();
    initCountryPopup();
  });
})();
